<div class="modal-header">
  <div class="modal-header-container">
    <p class="modal-title">Create aggregation</p>
    <p class="modal-subtitle">Here you can create a customize aggregation of your input portolios</p>
  </div>
  <i class="ic-close icon-size-32" (click)="activeModal.dismiss('Cross click')"></i>
</div>
<form [formGroup]="addAggregationForm" (submit)='onSubmit(addAggregationForm)' novalidate>
  <div class="modal-body">
    <div class="form-container">
      <div class="form-group">
        <label
          for='name'
          class="input-title"
          [class.text-error]="submitted && addAggregation.name.invalid"
        >
          Name
        </label>
        <input
          formControlName="name"
          class="form-control"
          type="text"
          placeholder="Insert Name"
          [class.is-invalid]="submitted && addAggregation.name.invalid"
          ngbAutofocus>
        <small class="invalid-feedback text-error" *ngIf="addAggregation.name.errors && submitted">
          <span *ngIf="addAggregation.name.errors.required">Name is mandatory. Please fill the field!</span>
        </small>
      </div>
      <div class="form-group">
        <label
          for="typeahead-focus"
          class="input-title"
          [class.text-error]="submitted && addAggregation.list.invalid"
        >Portfolio</label>
        <ng-select
          [items]="portfoliosName"
          [multiple]="true"
          [hideSelected]="true"
          bindLabel='name'
          [virtualScroll]="true"
          class="custom"
          [searchable]='true'
          formControlName='list'
          placeholder="start typing a name"
          [class.is-invalid]="submitted && addAggregation.list.invalid"
        >
          <!-- this is selected -->
          <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
            <div class="ng-value" *ngFor="let item of items | slice:0:2">
              <span class="ng-value-label">{{item.name_portfolio}}</span>
              <span class="icon" (click)="clear(item)" aria-hidden="true">×</span>
            </div>
            <div class="ng-value" *ngIf="items.length > 2">
              <span class="ng-value-label">{{items.length - 2}} more...</span>
            </div>
          </ng-template>
          <!-- this is option -->
          <ng-template ng-option-tmp let-item="item">
            <div class="d-inline-flex w-100 align-items-center justify-content-between">
              <span class="ng-value-label">{{item.name_portfolio}}</span>
              <i *ngIf="!item.disabled" class="ic-add"></i>
            </div>
          </ng-template>
        </ng-select>
        <small class="invalid-feedback text-error" *ngIf="addAggregation.list.errors && submitted">
          <span *ngIf="addAggregation.list.errors.required">Portfolios is mandatory. Please fill the field!</span>
          <span *ngIf="addAggregation.list.errors.minLengthArray">Portfolios must be more than one</span>
        </small>
      </div>
    </div>
  </div>
  <div class="modal-footer pt-5">
    <button type="button" class="btn btn-outline-dark" (click)="onDelete()">Cancel</button>
    <button type='submit' class="btn btn-default ml-3" [ngClass]="{'btn-disabled disabled': validation}">Create</button>
  </div>
</form>
